<template>
  <!-- TKP-194: ağaç satırındaki değerler — sütunlu bölümlerde bölümün sütunlarıyla küçük tablo, kısa değerli bölümlerde sarmalanan çipler.
       `aggregated`: birim/süreç satırı (kaç veride; 🗑 = altındaki tümünden); değilse veri/ilgili kişi satırı (🗑 tek kayıt, ✎ düzenle). -->
  <div v-if="values.length" class="hi-values small" :class="{ 'd-inline-block ml-2': !headers }" data-test="hi-values">
    <table v-if="headers" class="table table-sm table-borderless mb-1 hi-values-table" data-test="hi-values-table">
      <thead>
        <tr class="text-muted">
          <th v-for="h in headers" :key="h" class="py-0 font-weight-normal">{{ $t(h) }}</th>
          <th v-if="aggregated" class="py-0 text-right" style="width: 4rem;">{{ $t("inventory.hierarchy.col-count") }}</th>
          <th class="py-0" style="width: 4rem;"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="v in values" :key="v.key" data-test="hi-chip">
          <td v-for="(c, ci) in v.columns" :key="ci" class="py-0" :class="{ 'text-muted': v.removal }"><del v-if="v.removal" data-test="hi-removal">{{ c || "—" }}</del><template v-else>{{ c || "—" }}</template><b-badge v-if="ci === 0 && v.draft" :variant="v.removal ? 'warning' : 'info'" class="ml-1" data-test="hi-draft-item"><i class="bx" :class="v.removal ? 'bx-trash' : 'bx-edit'"></i> {{ $t(draftKey(v)) }}</b-badge></td>
          <td v-if="aggregated" class="py-0 text-right text-muted">·{{ v.count }}</td>
          <td class="py-0 text-nowrap">
            <i v-if="v.ids.length" class="bx bx-trash text-danger hand" data-test="hi-chip-remove" v-b-tooltip.hover :title="aggregated ? $t('inventory.hierarchy.remove-all', { count: v.ids.length }) : $t('inventory.hierarchy.remove-one')" @click="$emit('remove', v)"></i>
            <i v-if="editable && !aggregated" class="bx bx-pencil text-warning hand ml-1" data-test="hi-chip-edit" v-b-tooltip.hover :title="$t('common.edit')" @click="$emit('edit', v)"></i>
          </td>
        </tr>
      </tbody>
    </table>
    <template v-else>
      <span v-for="v in values" :key="v.key" class="mr-2 text-nowrap d-inline-block" data-test="hi-chip">
        <del v-if="v.removal" class="text-muted" data-test="hi-removal">{{ v.text }}</del><template v-else>{{ v.text }}</template><small v-if="aggregated" class="text-muted"> ·{{ v.count }}</small>
        <i v-if="v.ids.length" class="bx bx-trash text-danger hand ml-1" data-test="hi-chip-remove" v-b-tooltip.hover :title="aggregated ? $t('inventory.hierarchy.remove-all', { count: v.ids.length }) : $t('inventory.hierarchy.remove-one')" @click="$emit('remove', v)"></i>
        <i v-if="editable && !aggregated" class="bx bx-pencil text-warning hand ml-1" data-test="hi-chip-edit" v-b-tooltip.hover :title="$t('common.edit')" @click="$emit('edit', v)"></i>
        <b-badge v-if="v.draft" :variant="v.removal ? 'warning' : 'info'" class="ml-1" data-test="hi-draft-item"><i class="bx" :class="v.removal ? 'bx-trash' : 'bx-edit'"></i> {{ $t(draftKey(v)) }}</b-badge>
      </span>
    </template>
  </div>
</template>

<script>
import { draftBadgeKey } from "@modules/approval/draft-overlay";
export default {
  name: "hi-values",
  props: { values: { type: Array, default: () => [] }, headers: { type: Array, default: null }, aggregated: { type: Boolean, default: false }, editable: { type: Boolean, default: false } },
  methods: {
    draftKey(v) {
      const x = (v.items || []).find((i) => (i.item && i.item.__draft) || i.draft);
      return draftBadgeKey(x ? (x.item && x.item.__draft ? x.item : { __draft: x.draft }) : null);
    },
  },
};
</script>

<style scoped>
.hi-values-table { width: auto; max-width: 100%; }
.hi-values-table td, .hi-values-table th { border: 0; padding-left: 0.4rem; padding-right: 0.4rem; vertical-align: top; }
</style>
